"use client";

import { useEffect } from "react";
import type { DietCatalogDetail } from "@/features/diets/types";
import { sendEvent } from "../../gtm/event";

export const EventCustomizeDiet = ({
  item,
  edit,
  kcal,
}: {
  item: DietCatalogDetail;
  edit?: boolean;
  kcal?: string;
}) => {
  useEffect(() => {
    sendEvent({
      event: edit ? "CUSTOMIZE_DIET_EDIT" : "CUSTOMIZE_DIET",
      ecommerce: {
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            item_brand: item.catering.name,
            item_category: item.tags.map((tag) => tag.slug).join(", "),
            item_category2: kcal || String(item.base.caloricity),
            item_variant: item.menuSelection ? "diet with choice" : "diet",
          },
        ],
      },
    });
  }, []);

  return null;
};
